import { Circle, ColorType, TouchableBox, useTheme, AHIcon } from "arkh";

import React from "react";

export function LoginItem({
  isLoggingIn,
  backgroundColor,
  login,
}: {
  isLoggingIn: boolean;
  backgroundColor?: ColorType;
  login: () => void;
}) {
  const color = useTheme();
  return (
    <TouchableBox
      hitSlop={{
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
      }}
      pressRetentionOffset={{
        top: 20,
        bottom: 20,
        left: 20,
        right: 20,
      }}
      spaceRight="medium"
      onPress={login}
      color={backgroundColor ?? "surface"}
      style={{
        alignSelf: "stretch",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <Circle size="medium" color="surface-backgroundControl">
        <AHIcon
          type="log-in"
          forceSize={18}
          customColor={color.darkerText}
          spaceLeft="xxsmall"
        />
      </Circle>
    </TouchableBox>
  );
}
